import { animate } from 'animejs';
import { refs, domReady, booleanDataset, hasBooleanDataset } from '../modules/utils.js';

class ProductAccordion extends HTMLElement {
  static get observedAttributes() {
    return ['data-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      const prevIndex = parseInt(oldValue, 10);
      const index = parseInt(newValue, 10);
      this.refs.items?.forEach((el, i) => booleanDataset(el, 'active', i === index));
      this.#toggleItem(prevIndex);
      this.#toggleItem(index);
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.headers?.forEach(el => {
      el.addEventListener('click', () => {
        const index = Array.from(this.refs.headers).indexOf(el);
        this.dataset.index = this.dataset.index === index.toString() ? -1 : index;
      });
    });
  }

  #toggleItem(index) {
    if (isNaN(index) || index < 0) return;
    const el = this.refs.items[index];
    const isActive = hasBooleanDataset(el, 'active');
    const contentEl = el.querySelector('[data-content]');
    if (!contentEl) return;

    let height = 0;
    if (isActive) {
      contentEl.style.height = 'auto';
      height = contentEl.offsetHeight;
      contentEl.style.height = null;
    }

    animate(
      contentEl,
      {
        height,
        duration: 300,
        ease: 'outQuad',
      }
    );
  }
}

customElements.define('product-accordion', ProductAccordion);
